import { FORM_PATHS, openInModalOrPage } from '../../modals';

export const CREATE_COMMUNICATION_TYPE_COMPLETE = 'CompleteCommunication';

export const completeCommunication = communication => (dispatch, getState) => {
    dispatch(
        openInModalOrPage(
            FORM_PATHS.CompleteCommunicationModal,
            communication.communicationId,
            communication,
            communication.startDate
        )
    );
};
